/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

 theme.customerAddresses = (function () {
    var $newAddressForm = $("#address_form_new");
  
    if (!$newAddressForm.length) {
      return;
    }
  
    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      new Shopify.CountryProvinceSelector(
        "AddressCountryNew",
        "AddressProvinceNew",
        {
          hideElement: "AddressProvinceContainerNew",
        }
      );
    }
  
    // Initialize each edit form's country/province selector
    $(".address-country-option").each(function () {
      var formId = $(this).data("form-id");
      var countrySelector = "AddressCountry_" + formId;
      var provinceSelector = "AddressProvince_" + formId;
      var containerSelector = "AddressProvinceContainer_" + formId;
  
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector,
      });
    });
  
    $("[js-address-edit]").on("click", function () {
      var formId = $(this).data("form-id");
      $("#address_form_" + formId).toggle();
      $(".account-address__edit").toggle();
      $(".account-address__listing").toggle();
    });
  
    $("[js-address-delete]").on("click", function () {
      var $el = $(this);
      var formId = $el.data("form-id");
      var confirmMessage = $el.data("confirm-message");
      if (
        confirm(confirmMessage || "Are you sure you wish to delete this address?")
      ) {
        Shopify.postLink("/account/addresses/" + formId, {
          parameters: {
            _method: "delete",
          },
        });
      }
    });
  })();
  
  /**
   * Password Template Script
   * ------------------------------------------------------------------------------
   * A file that contains scripts highly couple code to the Password template.
   *
   * @namespace password
   */
  
  theme.customerLogin = (function () {
    var config = {
      recoverPasswordForm: "[js-show-recover]",
      hideRecoverPasswordLink: "[js-hide-recover]",
    };
  
    if (!$(config.recoverPasswordForm).length) {
      return;
    }
  
    checkUrlHash();
    resetPasswordSuccess();
  
    $(config.recoverPasswordForm).on("click", onShowHidePasswordForm);
    $(config.hideRecoverPasswordLink).on("click", onShowHidePasswordForm);
  
    function onShowHidePasswordForm(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    }
  
    function checkUrlHash() {
      var hash = window.location.hash;
  
      // Allow deep linking to recover password form
      if (hash === "#recover") {
        toggleRecoverPasswordForm();
      }
    }
  
    /**
     *  Show/Hide recover password form
     */
    function toggleRecoverPasswordForm() {
      $(".login__recover").toggle();
      $(".login__login").toggle();
    }
  
    /**
     *  Show reset password success message
     */
    function resetPasswordSuccess() {
      var $formState = $(".reset-password-success");
  
      // check if reset password form was successfully submited.
      if (!$formState.length) {
        return;
      }
  
      // show success message
      $("#ResetSuccess").removeClass("hide");
    }
  })();
  
  theme.AccountDashboard = (function () {
    function AccountDashboard(container) {
      this.$container = $(container);
  
      enquire.register(theme.config.mediaQueries.smallDown, {
        match: function () {
          $("#account__overview", this.$container).attr("aria-hidden", true);
          $('[aria-controls="account__overview"]', this.$container).attr(
            "aria-expanded",
            false
          );
        },
        unmatch: function () {
          $(".account__accordion-header", this.$container).attr(
            "aria-expanded",
            true
          );
          $("#account__orders, #account__overview", this.$container)
            .removeAttr("aria-hidden")
            .removeAttr("style");
        },
      });
    }
  
    return AccountDashboard;
  })();
  
  theme.AccountAddress = (function () {
    function AccountAddress(container) {
      this.$container = $(container);
  
      enquire.register(theme.config.mediaQueries.smallDown, {
        match: function () {
          $("#account-address-list", this.$container).attr("aria-hidden", true);
          $('[aria-controls="account-address-list"]', this.$container).attr(
            "aria-expanded",
            false
          );
        },
        unmatch: function () {
          $(".account__accordion-header", this.$container).attr(
            "aria-expanded",
            true
          );
          $("#account-address-new, #account-address-list", this.$container)
            .removeAttr("aria-hidden")
            .removeAttr("style");
        },
      });
    }
  
    return AccountAddress;
  })();